import { createContext } from 'react';
import { ProductDetailsResponse } from '../types/components';

// @ts-ignore
const ProductContext = createContext<ProductDetailsResponse>(null);

export default ProductContext;
